<div class="lvi-content">
    <div class="avatar" [nSelector]="{ liste: liste, item: data }">
        <i class="material-icons-outlined">label</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ data.libelle }}</a>
        </div>
    </div>
</div>